<template>
  <v-popover
      placement="bottom"
      offset="11"
      :disabled="disabled"
      open-group="transaction-remove-popover"
      popoverClass="transaction-remove-popover">
    <div class="flex items-center text-text-ternary
                cursor-pointer hover:text-red group"
         :class="{'opacity-50':disabled}"
         v-tooltip="disabled && disabledTooltip">
      <span class="transition duration-200">
        <slot name="icon"><IconTrash/></slot>
      </span>
      <span v-if="$slots.text"
            class="text-2sm ml-4 transition duration-200 border-b border-dashed border-border group-hover:border-red">
        <slot name="text"/>
      </span>
    </div>
    <template slot="popover">
      <div class="col-span-2">
        <slot name="popover">
          <p class="text-text text-lg font-bold">{{ $t('areYouSure') }}</p>
          <p class="text-text-ternary text-2sm" v-if="revertIsImpossible">{{ $t('revertIsImpossible') }}</p>
        </slot>
      </div>
      <BaseButton size="sm"
                  :loading="!!submitted"
                  @click="$emit('confirm')"
                  theme="red">{{ buttonsText.apply }}
      </BaseButton>
      <BaseButton size="sm"
                  v-close-popover
                  :loading="!!submitted"
                  theme="white-bordered">{{ buttonsText.cancel }}
      </BaseButton>
    </template>
  </v-popover>
</template>

<script>

import IconTrash from "@/components/icons/IconTrash";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "ArchiveBtn",
  components: {BaseButton, IconTrash},
  props: {
    submitted: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledTooltip: {
      type: String
    },
    revertIsImpossible: {
      type: Boolean,
      default: false
    },
    buttonsTextType: {
      type: String,
      default: 'yes-no',
      validator: (val) => ['yes-no', 'del-cancel'].includes(val)
    }
  },
  computed: {
    buttonsText() {
      const texts = {
        'yes-no': {
          apply: this.$t('yes'),
          cancel: this.$t('no')
        },
        'del-cancel': {
          apply: this.$t('delete'),
          cancel: this.$t('cancel')
        }
      }
      return texts[this.buttonsTextType];
    }
  },
  i18n: {
    messages: {
      en: {
        areYouSure: 'Are you sure?',
        revertIsImpossible: 'Cancel this action is impossible',
        remove: 'Delete',
        yes: 'Yes',
        no: 'No',
        delete: 'Delete',
        cancel: 'Cancel'
      },
      ru: {
        areYouSure: 'Вы уверены?',
        revertIsImpossible: 'Отменить действие невозможно',
        remove: 'Удалить',
        yes: 'Да',
        no: 'Нет',
        delete: 'Удалить',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip.popover.transaction-remove-popover {
  &:before {
    position: fixed;
    content: '';
  }

  &:focus {
    @apply outline-none;
  }

  .popover-inner {
    @apply p-4 bg-block shadow-primaryBlock rounded;
    width: 250px;
    z-index: 2;

    > div {
      @apply grid grid-cols-2 col-gap-4 row-gap-4;
    }
  }

  &[x-placement^="top"] {
    .popover-arrow {
      border-width: .8rem .8rem 0 .8rem;
      bottom: -.8rem;
    }
  }

  &[x-placement^="bottom"] {
    .popover-arrow {
      top: -.8rem;
      border-width: 0 .8rem .8rem .8rem;
    }
  }

  .popover-arrow {
    @apply border-block;
    z-index: 1;
    filter: drop-shadow(0px 4px 8px rgba(86, 114, 155, 0.6));

  }
}
</style>
